import { apiClient } from "helpers/api_helper";
export const calculateExchangeSaleOrderPrices = async (data: {
    salesOrderId: number;
    // ReturnSalesType: string;
    returnSalesOrderItems: Array<{
        salesOrderItemId: number;
        materialTypeId: number;
        quantity: number;
        finalSaleOrderPrice: number;
    }>;
}) => {
    try {
        // console.log(JSON.stringify(data))
        const response = await apiClient.post(`/api/v1/SalesEntry/CalculateExchangeSaleOrderPrices`, data);
        // console.log(response)
        return response;
    } catch (error: any) {
        throw new Error(error.message);
    }
};
// export const createGoldMakingCharges = async (data: object) => {
//     try {
//         const response = await apiClient.post('/api/v1/MakingCharges/InsertGoldMakingCharges', data);
//         return response;
//     } catch (error: any) {
//         throw new Error(error.message);
//     }
// };